import * as Sentry from "@sentry/angular";

import { environment } from "../environments/environment";
import { shouldDropEvent } from "./sentry-event-filter";

if (isSentryAvailable()) {
  Sentry.init({
    dsn: environment.glitchDns,
    environment: environment.production
      ? "production"
      : environment.staging
        ? "staging"
        : environment.sandbox
          ? "sandbox"
          : undefined,
    dataCollection: { userInfo: false },
    beforeSend: (event, hint) => (shouldDropEvent(event, hint) ? null : event),
  });
}

function isSentryAvailable(): boolean {
  return Boolean(environment.glitchDns) && window.location.hostname !== "localhost";
}
